import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/authContext";

// PrivateRoute component to guard access
const PrivateRoute = ({ element, ...rest }) => {
  const { token } = useAuth();

  if (!token) {
    // Redirect to signin page if not logged in
    return <Navigate to="/signin" replace />;
  }

  return element;
};

export default PrivateRoute;
